/* eslint-disable no-undef */
import request from './request'
import {getCookie} from "@/helpers";
import {api} from "./requestGraphql";

const getAdvertisers = async (data) => {
    try {
        let preparedFilters = ''

        for (const filter in data.filters) {
            preparedFilters += (!!data.filters[filter]) ?
                `${filter}: "${data.filters[filter]}"` : ''
        }

        const workspace = localStorage.getItem('workspace');

        const result = await request.post(`/graphql`, {
            query: `
              {
                advertiserProfiles(pagination: {
                  page: ${data.page},
                  limit: ${data.limit}
                }, sorting: {
                  orderBy: "${data.orderBy}",
                  orderDirectionAsc: ${data.orderDirectionAsc}
                }, filters: {${preparedFilters}}) {
                  count,
                  data {
                    id,
                    name,
                    tags,
                    email,
                    dateAdded,
                    status,
                    advertiserManager,
                    margin,
                    advertiserManagerId,
                    verified
                    verticalNames
                    billingCycle
                  }
                }
              }
            `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        )

        return {
            data: result.data.data.advertiserProfiles.data,
            count: result.data.data.advertiserProfiles.count
        }

    } catch (err) {
        console.error(err)
    }
}

export const getPresignedUrlAdvertiser = async (filename, advertiserId, method, type) => {
    try {
        const response = await api.post('', {
            query: `
                mutation {
                  getAdvertiserPresignedUrl(
                    filename: "${filename}"
                    advertiserId: ${advertiserId}
                    method: "${method}"
                    type: "${type || ''}"
                  )
                }
              `,
        });

        const presignedUrl = response.data.data.getAdvertiserPresignedUrl;
        console.log(`Presigned URL: ${presignedUrl}`);
        return presignedUrl;
    } catch (error) {
        console.error('Error fetching presigned URL:', error);
        throw error;
    }
};

export const getAdvertiserInfo = async (advertiserId) => {
    try {
        const workspace = localStorage.getItem('workspace');

        const result = await request.post(`/graphql`, {
                query: `
              {
                getAdvertiserInfo(advertiserId: ${advertiserId}) {
                  advertiserId
                  advertiserName
                  status
                  advertiserManagerId
                  advertiserManagerName
                  originId
                  website
                  tags
                  descriptions
                  advertiserDateAdded
                  advertiserDateUpdated
                  tokenVersion
                  email
                  verified
                  description
                  gatewayTokenVersion
                  margin
                  paymentMethodId
                  paymentDetails
                  featured
                  billingCycle
                  firstName
                  lastName
                  businessName
                  topGeos
                  offeredProducts
                  otherNetworks
                  trafficTypes
                  advertiserVerticals
                  websites
                  createdAt
                  updatedAt
                  emails
                  imService
                  imContact
                  verticalNames
                  companyName
                  paymentMethodName
                  subAdvertiser
                  restrictedTrafficTypes
                  files {
                    filename
                    url
                    urlAttachment
                    size
                  }                  
                }
              }
            `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.getAdvertiserInfo;

    } catch (err) {
        console.error(err);
    }
}

const getFilter = async (data) => {
    // todo: reusable fragment
    const preparedFilter = []
    if(data.filter) {
        for (let i = 0; i < data.filter.length; i++) {
            preparedFilter.push(
                (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: [${data.filter[i].value.map(v => `"${v}"`)}] }` : ''
            )
        }
    }

    data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

    const result = await request.post(`/graphql`, {
        query: `
          {
            advertiserFilterData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", ${data.filter}) {
              key,
              value
            }
          }
        `
        },
        {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        }
    )

    if(result.status === 200) {
        const prettyData = [];
        if(result.data.data.advertiserFilterData) {
            for(let i = 0; i < result.data.data.advertiserFilterData.length; i++) {
                prettyData.push(result.data.data.advertiserFilterData[i]);
            }
            return prettyData;
        }
    }
}

const getPayments = async (data) => {
    const result = await request.post(`/graphql`, {
            query: `
                {
                  advertiserPayments(advertiserId: ${data.advertiser_id}) {
                    id
                    date_added
                    status
                    amount
                    total_revenue
                    advertiser_id
                    start_period
                    end_period
                    billing_cycle
                    symbol
                    currency_name
                    modifications
                    revenue
                  }
                }

        `
        },
        {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        }
    )

    if(result.status === 200) {
        const prettyData = [];
        if(result.data.data.advertiserPayments) {
            for(let i = 0; i < result.data.data.advertiserPayments.length; i++) {
                prettyData.push(result.data.data.advertiserPayments[i]);
            }
            return prettyData;
        }
    }
}

const createAdvertiser = async (data) => {
    console.log('createAdvertiser', data);

    const verticals = data.verticals && data.verticals.length ? `[${data.verticals.join(',')}]` : '[]';

    const paymentDetails = JSON.stringify(data.paymentDetails).replace(/"/g, '\\"');
    const files = JSON.stringify(data.files).replace(/"/g, '\\"');

    const result = await request.post(`/graphql`, {
            query: `
                mutation{
                    addAdvertiser (data: {
                        name: "${data.name}", 
                        status: "${data.status}",
                        advertiser_manager_id: "${data.advertiserManager}",
                        descriptions: """${data.description}""",
                        product_description: "${data.productDescription}",
                        business_name: "${data.businessName}",
                        website: "${data.website}",
                        emails: "${data.emails}",
                        margin: ${data.margin},
                        verticals: ${verticals}
                        imService: "${data.imService}",
                        imContact: "${data.imContact}",
                        paymentMethodId: ${data.methodId},
                        paymentDetails: "${paymentDetails}"
                        billingCycle: "${data.billingCycle}"
                        files: "${files}"
                      }
                    ) {
                      id
                      name
                      description    
                      website 
                      status
                      advertiserManager
                      email
                      margin
                    }
              }
            `
        },
        {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        }
    )
    return result
}

export const getAdvertiserVerticals = async ({advertiser_id}) => {

    const result = await request.post(`/graphql`, {
            query: `
                query {
                    getAdvertiserVerticals(id: ${advertiser_id}) {
                        id
                        verticalId
                        advertiserId
                        dateAdded
                        verticalName
                    }
                }
            `
        },
        {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Policy': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        }
    );

    return result.data.data.getAdvertiserVerticals;
}


const updateAdvertiser = async (data) => {

    try {
        const res = await api.post(
            '', {
                query: `
                      mutation{
                        updateAdvertiser(
                          id: ${data.id}
                          name: "${data.name}"
                          status: "${data.status}"
                          managerId: ${data.managerId}
                          verified: "${data.verified}"
                          margin: ${data.margin}
                          billingCycle: "${data.billingCycle}"
                        ){
                          id
                          name
                          status
                          managerId
                          verified
                          margin
                        }
                      },

                `,
            }
        )

        let response = res.data.data.updateAdvertiser
        console.log(`\nUpdateAdvertiser : { ${JSON.stringify(response)} } `)
        return response
    } catch (e) {
        console.log(e)
    }
}
const updateAdvertiserInfo = async (data) => {
    console.log('updateAdvertiserInfo', data);

    try {
        const escapeString = (str) => str
          .replace(/\\/g, '\\\\')
          .replace(/"/g, '\\"')
          .replace(/\n/g, '\\n');

        const websitesArray = `[${data.websites.map(website => `{ site: "${escapeString(website.site)}", desc: "${escapeString(website.desc)}" }`).join(', ')}]`;

        const contactsArray = `[${data.contacts.map(contact => `{ id: ${contact.id || null}, email: "${contact.email}", isPrimary: ${contact.isPrimary} }`).join(', ')}]`;

        const files = JSON.stringify(data.files).replace(/"/g, '\\"');
        const savedFiles = JSON.stringify(data.savedFiles).replace(/"/g, '\\"');
        const verticalsArray = `[${data.selectedVerticals
            .map(vertical => `{ id: ${vertical.id || null}, name: "${vertical.name || ''}" }`)
            .join(', ')}]`;

        const res = await api.post(
            '',
            {
                query: `
                  mutation {
                    updateAdvertiserInfo(
                      id: ${data.advertiserId}
                      name: "${data.advertiserName}"
                      status: "${data.status}"
                      managerId: ${data.advertiserManagerId}
                      billingCycle: "${data.billingCycle}"
                      verified: ${data.verified ? `"${data.verified}"` : null}
                      margin: ${data.margin}
                      email: "${data.email}"
                      tags: "${data.tags}"
                      description:"""${data.description}"""
                      websites: ${websitesArray}
                      contacts: ${contactsArray}
                      verticals: ${verticalsArray}
                      topGeos: ${JSON.stringify(data.topGeos)} 
                      otherNetworks: ${JSON.stringify(data.otherNetworks)} 
                      imService: "${data.imService}"
                      imContact: "${data.imContact}"
                      paymentMethodId: ${data.paymentMethodId}
                      paymentDetails: "${JSON.stringify(data.paymentDetails).replace(/"/g, '\\"')}"
                      businessName: "${data.businessName}" 
                      companyName: "${data.companyName || ''}"
                      paymentMethodName: "${data.paymentMethodName || ''}"
                      subAdvertiser: "${data.subAdvertiser || ''}"
                      trafficTypes: """${data.trafficTypes || '[]'}"""
                      restrictedTrafficTypes: """${data.restrictedTrafficTypes || '[]'}"""
                      files: "${files}"
                      savedFiles: "${savedFiles}"
                    ) {
                      advertiserId
                      advertiserName
                      status
                      advertiserManagerId
                      verified
                      margin
                      email
                      tags
                      description
                      websites
                      verticalNames
                    }
                  }
                `,
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Policy': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                }
            }
        );

        const response = res.data.data.updateAdvertiserInfo;
        console.log(`\nUpdateAdvertiserInfo response: ${JSON.stringify(response)}`);
        return response;
    } catch (e) {
        console.error('Error updating advertiser:', e);
        return null;
    }
};




const getNotesList = async (id) => {
    try {
        const result = await request.post(`/graphql`, {
            query: `{
              advertiserNotesList(
                id:${id}
              ){
                id
                author
                note
                email
                dateAdded
              }}
            `,
        }, {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        })

        return result.data.data.advertiserNotesList;
    } catch (err) {
        console.log(err)
        throw err;
    }
}

const createNote = async (data) => {
    try {
        const result = await request.post(`/graphql`, {
            query: `
                mutation{
                  createAdvertiserNote(note: """${data.note}""", id: ${data.id}) {
                    id
                  }
                }
            `,
        }, {
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        })

        return result.data.data.createAdvertiserNote;
    } catch (err) {
        console.log(err)
        throw err;
    }
}

const updateNote = async (data) => {
    try {
        const result = await request.post(`/graphql`, {
            query: `
                mutation{
                  updateAdvertiserNote(note: """${data.note}""", id: ${data.id}, isDeleted: ${data.isDeleted})
                }
            `,
            }, {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': localStorage.getItem('workspace') || 'ac'
                }
            }
        )
        return result.data.data.updateAdvertiserNote;
    } catch (err) {
        console.log(err)
        throw err;
    }
}

const getPostbacks = async (data) => {
    const workspace = localStorage.getItem('workspace');
    try {
        const result = await request.post(`/graphql`, {
                query: `
                     {
                      getAdvertiserPostbacks(advertiserId:${data.id}){
                        id
                        url
                        eventType
                        isDefault
                      }
                    }
                `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.getAdvertiserPostbacks;

    } catch (err) {
        console.error(err)
    }
}

const getContacts = async (data) => {
    const workspace = localStorage.getItem('workspace');
    try {
        const result = await request.post(`/graphql`, {
                query: `
                     {
                      getAdvertiserContacts(advertiserId: ${data.id}) {
                        id
                        advertiserId
                        isPrimary
                        email
                      }
                    }
                `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.getAdvertiserContacts;

    } catch (err) {
        console.error(err)
    }
}
const getAdvertiserHistory = async (data) => {
    const workspace = localStorage.getItem('workspace');
    try {
        const result = await request.post(`/graphql`, {
                query: `
                    {
                      getAdvertiserHistory(advertiserId: ${data.id}) {
                        user
                        dateAdded
                        action
                        logs
                      }
                    }
                `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Policy': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.getAdvertiserHistory;

    } catch (err) {
        console.error(err);
    }
}

const getParams = async (data) => {
    const workspace = localStorage.getItem('workspace');
    try {
        const result = await request.post(`/graphql`, {
                query: `
                     {
                      getAdvertiserParams(advertiserId: ${data.id}) {
                        key_value
                        rename_to
                      }
                    }
                `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.getAdvertiserParams;

    } catch (err) {
        console.error(err)
    }
}

const getTermsAndMethods = async (data) => {
    const workspace = localStorage.getItem('workspace');
    try {
        const result = await request.post(`/graphql`, {
                query: `
                     {
                       getPaymentInfo{
                         terms{
                           id
                           name
                         }
                         methods{
                           id
                           name
                           tipalti
                         }
                       }
                     }
                `
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.getPaymentInfo;

    } catch (err) {
        console.error(err)
    }
}

const updatePostbackItems = async (data, deletedIds, advertiserId) => {
    const workspace = localStorage.getItem('workspace');
    try {
        const result = await request.post(`/graphql`, {
                query: `
                     mutation updatePostback($postbacks: [PostbackInput!]!, $deletedIds:[Int], $advertiserId: Int!) {
                        updatePostback(postbacks: $postbacks, deletedIds: $deletedIds, advertiserId: $advertiserId) {
                          id
                          eventType
                          isDefault
                          url
                        }
                      }
                `,
                variables: {
                    postbacks: data,
                    deletedIds: deletedIds,
                    advertiserId: advertiserId
                }
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.updatePostbackItems;

    } catch (err) {
        console.error(err)
    }
}

const updateParams = async (data, advertiserId) => {
    const workspace = localStorage.getItem('workspace');
    try {
        const result = await request.post(`/graphql`, {
                query: `
                     mutation updateParam($params: [ParamInput!]!, $advertiserId: Int!) {
                        updateParam(params: $params, advertiserId: $advertiserId)
                     }   
                `,
                variables: {
                    params: data,
                    advertiserId: advertiserId
                }
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': workspace
                }
            }
        );

        return result.data.data.updatePostbackItems;

    } catch (err) {
        console.error(err)
    }
}

const insertOrUpdateAdvertiserContacts = async (advertiserId, contacts) => {
    try {
        const result = await request.post(`/graphql`, {
            query: `
                    mutation {
                      insertOrUpdateAdvertiserContacts(advertiserId: ${advertiserId}, data: [
                        ${contacts.map(({ email, isPrimary }) => `{ email: "${email}", isPrimary: ${isPrimary} }`).join(',')}
                      ])
                    }
                `
        },{
            headers: {
                'Authorization': getCookie('accessToken'),
                'Referrer-Police': 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                'workspace': localStorage.getItem('workspace') || 'ac'
            }
        });

        return result.data.data.insertOrUpdateAffiliateContacts;
    } catch (error) {
        console.error('Error inserting or updating affiliate contacts:', error);
        return null;
    }
};

export default {
    getAdvertisers,
    getAdvertiserInfo,
    getFilter,
    getPayments,
    createAdvertiser,
    getAdvertiserVerticals,
    updateAdvertiser,
    getNotesList,
    createNote,
    updateNote,
    getPostbacks,
    updatePostbackItems,
    getContacts,
    getParams,
    updateParams,
    getTermsAndMethods,
    insertOrUpdateAdvertiserContacts,
    getAdvertiserHistory,
    updateAdvertiserInfo,
    getPresignedUrlAdvertiser
}
